var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZendesk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2379 9C15.2379 11.5254 13.1703 13.5721 10.6183 13.5721C8.06761 13.5721 6 11.5254 6 9H15.2379Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7607 23.9999C16.7607 21.4745 18.8284 19.4278 21.3804 19.4278C23.931 19.4278 26 21.4745 26 23.9999H16.7607Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2379 12.9614V24H6L15.2379 12.9614Z",
    fill: "#414141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7607 20.0386V9H25.9986L16.7607 20.0386Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZendesk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Zendesk.5f9df9fbaf67bb7bd8b4d57cec07425a.svg";